import type { FC, ReactNode } from 'react'

import { Button } from '@/components/generals/button'

export const Story: FC = (): ReactNode => {
    return (
        <section className='about-section section-padding'>
            <div className='w-layout-blockcontainer container w-container'>
                <div className='section-content-wrapper about'>
                    <div className='about-left' data-reveal='slide-right'>
                        <div className='about-left-top'>
                            <h2 className='section-title style-02'>
                                Your trusted painting partner
                            </h2>

                            <p className='about-subheading'>
                                At NG Painting Pro, we bring years of expertise and a passion for
                                perfection to every project.
                            </p>

                            <p className='section-subtitle style-02 about'>
                                Whether it is a cozy home interior or a large industrial facility,
                                every job gets the same dedication to excellence. Our skilled team
                                uses only premium materials and proven techniques to deliver
                                results that last.
                            </p>

                            <p className='section-subtitle style-02 about'>
                                We are licensed and fully insured, we keep every work site clean
                                and organized, and our pricing is transparent with no hidden fees.
                                Satisfaction is guaranteed on every project.
                            </p>
                        </div>

                        <Button href='/about' label='Read Our Story' variant='style-02' />
                    </div>

                    <div className='about-right' data-reveal='image'>
                        <img
                            src='/images/ng/gallery/painter-working.jpg'
                            loading='lazy'
                            alt='NG Painting Pro painter on a ladder finishing the trim of a blue house'
                            className='about-image'
                        />

                        <div className='about-counter-wrapper'>
                            <div className='single-counter'>
                                <div className='about-counter-number-wrapper'>
                                    <p className='about-counter-number'>
                                        <span data-counter='25'>
                                            25
                                        </span>

                                        <span className='counter-number-span'>
                                            +
                                        </span>
                                    </p>

                                    <p className='about-counter-label'>
                                        Years of Experience
                                    </p>
                                </div>

                                <p className='about-counter-content'>
                                    Painting homes and businesses across Massachusetts since 2000.
                                </p>
                            </div>

                            <div className='single-counter'>
                                <div className='about-counter-number-wrapper'>
                                    <p className='about-counter-number'>
                                        <span data-counter='500'>
                                            500
                                        </span>

                                        <span className='counter-number-span'>
                                            +
                                        </span>
                                    </p>

                                    <p className='about-counter-label'>
                                        Happy Customers
                                    </p>
                                </div>

                                <p className='about-counter-content'>
                                    Homeowners and businesses from the South Coast to Cape Cod
                                    and Greater Boston.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
